import { SortPipe } from './pipes/sort.pipe';
import { KeysPipe } from './pipes/keys.pipe';
import { BrowserModule} from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatButtonModule, MatDialogModule, MatInputModule, MatListModule,
         MatTabsModule, MatRadioModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { AngularFirestoreModule } from 'angularfire2/firestore';

import { AppComponent } from './app.component';
import { MatrixDialogComponent } from './matrix-dialog/matrix-dialog.component';
import { ListComponent } from './list/list.component';
import { MatrizComponent } from './matriz/matriz.component';
import { NuevoMiembroComponent } from './nuevo-miembro/nuevo-miembro.component';
import { SameUserPipe } from './same-user.pipe';

const routes = [{
  path: '',
  component: ListComponent
}, {
  path: 'matriz/:name',
  component: MatrizComponent
}];

const firebaseConfig = {
  apiKey: 'AIzaSyB-8y9qwgXDnP_XtMc8nKUeKk_6Wy7Sj4o',
  authDomain: 'matriz-de-conflicto.firebaseapp.com',
  databaseURL: 'https://matriz-de-conflicto.firebaseio.com',
  projectId: 'matriz-de-conflicto',
  storageBucket: 'matriz-de-conflicto.appspot.com',
  messagingSenderId: '767153690108'
};

@NgModule({
  declarations: [
    AppComponent,
    MatrixDialogComponent,
    ListComponent,
    MatrizComponent,
    KeysPipe,
    SortPipe,
    NuevoMiembroComponent,
    SameUserPipe
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatListModule,
    MatTabsModule,
    MatRadioModule,
    AngularFirestoreModule,
    RouterModule.forRoot(routes)
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [
    MatrixDialogComponent,
    NuevoMiembroComponent
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts